.registerCard {
	max-width: 36rem;
}

.registerCardOverlay {
	display: none;
}

@media screen and (max-width: 1350px) {
	.registerCardOverlay {
		display: block;
		position: relative;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		background-color: black;
		opacity: 70%;
	}
}
.title {
	font-size: 2rem;
}

.mainData > div {
	display: flex;
	flex-direction: row;
	justify-content: left;
}

.registerCardText {
	max-width: 20rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: var(--secondary);
	margin-left: 0.5rem;
}

.secondaryData > div {
	display: flex;
	flex-direction: row;
	justify-content: left;
}

.secondaryData > div:not(:first-child) {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.secondaryData > div:not(:first-child) > div {
	display: flex;
	flex-direction: row;
}

.secondaryData > div:first-child > p {
	max-width: 15rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.secondaryData > div:not(:first-child) {
	min-width: 23rem;
}

/* .registerCard {
	width: 40%;
	height: fit-content;
	gap: 1rem;
	padding: 1rem;
	background-color: var(--depth1);
	border-radius: var(--roundedBig);
}
.registerCard > div {
	display: flex;
	flex-direction: row;
	gap: 5px;
}
.registerCard > div > span {
	font-size: 1.5rem;
	font-weight: 600;
	color: var(--textPrimary);
}
.registerCard > div > p {
	font-size: 1.5rem;
	font-weight: 600;
	color: var(--secondary);
}
@media only screen and (max-width: 900px) {
	.registerCard {
		display: none;
	}
} */
